module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("The Medicine of Memory")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("A MEXICA CLAN IN CALIFORNIA")]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("by Alejandro Murguía")]), _vm._v(" "), _c('div', {
    staticClass: "publisher"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/logo.png"
    }
  }), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIVERSITY OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXAS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTIN")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cfb4d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 63
// module chunks = 0